module.exports = __webpack_public_path__ + "assets/img/17_1046.91b98bc0.jpg";